"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalInformationSave = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var PersonalInformationSave = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(PersonalInformationSave, _super);
    function PersonalInformationSave() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金贷个人信息保存接口';
        _this.code = '101122';
        _this.desc = '现金贷个人信息保存接口';
        _this.requestParams = new cashLoanAuth_1.PersonalInformationSaveRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return PersonalInformationSave;
}(service_1.BaseService));
exports.PersonalInformationSave = PersonalInformationSave;
//# sourceMappingURL=personalInformationSave.js.map